export enum SimSurveyDuration {
	Fixed,
	Indefinite
}